import React from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { IntensityMeter } from './components/IntensityMeter';
import { Gallery } from './components/Gallery';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { mockData } from './mock';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero 
        heroImage={mockData.heroImage}
        productImage="https://customer-assets.emergentagent.com/job_daa7ba14-6e78-4392-a8c9-fea003ba7172/artifacts/p6h44pf1_WhatsApp%20Image%202026-03-23%20at%2014.53.54.jpeg"
      />
      <About product={mockData.product} />
      <IntensityMeter pepperTypes={mockData.product.pepperTypes} />
      <Gallery images={mockData.gallery} />
      <Contact contactInfo={mockData.contact} />
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
